const API_URLS = {
  baseUrl: '',
  baseUrlDXL: 'https://eu2.api.vodafone.com',
  // baseUrlVFAL: 'https://api-sandbox-ci-vfal.vodafone.com',
  baseUrlVFAL: 'https://api-mobile-ci-vfal.vodafone.com',
  generatePin: '/csm-api/securityTokenAPI/v2/generateSecurityToken',
  validatePin: '/csm-api/securityTokenAPI/v2/validateSecurityToken/',
  getOfferDetails: '/auth/customerMarketingProductAPI/v1/customerMarketingProduct',
  getPreferences: '/auth/customerPrivacyProfileAPI/v2/customerPrivacyProfile',
  updatePreferences: '/auth/customerPrivacyProfileAPI/v2/customerPrivacyProfile/',
  searchAccount: '/auth/customerSystemUserAccountAPI/v2/customerSystemUserAccount/search',
  notify: '/auth/customerMarketingProductAPI/v1/customerMarketingProduct/notification',
  createOrder: '/auth/salesOrderAPI/v4/salesOrder'
}

const COMMON_HEADERS = {
  'Content-Type': 'application/json'
}

export { API_URLS, COMMON_HEADERS }
